/**
 * Stable role keys used by klab-admin-app.
 *
 * IAM role IDs may change between environments or migrations. Keep those IDs
 * centralized in APP_ROLES instead of spreading numeric values through guards
 * and components.
 */
export enum AppRole {
  Admin = "ADMIN",
  Accountant = "ACCOUNTANT",
}

export interface AppRoleDefinition {
  readonly id: number;
  readonly name: string;
}

export const APP_ROLES: Readonly<Record<AppRole, AppRoleDefinition>> = {
  [AppRole.Admin]: {
    id: 21,
    name: "Administrador",
  },
  [AppRole.Accountant]: {
    id: 45,
    name: "Contador",
  },
};
